import { ThirdPartyLoginWrapper } from './LoginOptions.styles';
import GoogleLoginButton from '../google/GoogleLoginButton';
import { MicrosoftLoginButton } from '../microsoft/MicrosoftLoginButton';
import { useMicrosoftLogin } from '../../hooks/useMicrosoftLogin';
import { useAppleLogin } from '../../hooks/useAppleLogin';
import AppleLoginButton from '../apple/AppleLoginButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const LoginOptions = ({
  onGoogleLoginClick,
  triggerReset,
  ssoRender
}) => {
  const {
    loginWithMicrosoft
  } = useMicrosoftLogin({
    handleError: triggerReset
  });
  const {
    loginWithApple
  } = useAppleLogin({
    handleError: triggerReset
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(ThirdPartyLoginWrapper, {
      children: [/*#__PURE__*/_jsx(GoogleLoginButton, {
        onClick: onGoogleLoginClick
      }), /*#__PURE__*/_jsx(MicrosoftLoginButton, {
        onClick: loginWithMicrosoft
      })]
    }), /*#__PURE__*/_jsxs(ThirdPartyLoginWrapper, {
      children: [/*#__PURE__*/_jsx(AppleLoginButton, {
        onClick: loginWithApple
      }), ssoRender()]
    })]
  });
};